import { zodResolver } from "@mantine/form";
import { inventoryItemLocationDataSchema } from "beitary-shared";
import { z } from "zod";

const writeLocationFormSchema = inventoryItemLocationDataSchema;

export type WriteLocationFormValues = z.infer<typeof writeLocationFormSchema>;

export const rules = zodResolver(writeLocationFormSchema);
